export default __webpack_public_path__ + "static/media/Death.61ecd153.png";